export default __webpack_public_path__ + "static/media/back-arrow.f7ee5065.svg";